<template>
  <div class="text-center">
  <div class="mt-4"><img src="/images/supalytic-icon.svg" width="50"></div>
    <div class="homepage_heading mt-2 pt-4 pb-4 px-3">Pricing</div>
    <div class="pricing-trial">You can try any plan <b>free</b> for <b>30 days</b></div>

    <div v-if="loading" class="text-center pb-3"><i class="fas fa-spinner fa-spin"></i></div>
    <div v-else-if="products.length == 0" class="text-center pb-3">No products</div>

      <div class="row" v-else>
        <div class="col-md-4 mb-4" v-for="(product, index) in products" :key="index">
          <div class="pricing-card h-100">
            <div class="pricing-card-header py-3">{{product.name}}</div>
            <div class="card-body pb-4">
              <div class="pricing-price">${{product.price}}<span class="pricing-text-muted">/month</span></div>
              <div class="pricing-monitor">Monitor {{product.sites}} {{product.sites == 1 ? 'website' : 'websites'}}</div>
              <a href="/register" class="btn btn-success px-4 start">Start free trial</a>
            </div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      products: [],
      loading: false,
    };
  },

  created() {
    this.getProducts();
  },

  methods: {
    getProducts() {

      this.loading = true;

      axios
        .get('/subscriptions/get-products')
        .then((response) => {
          this.products = response.data;
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
    },

  },
};
</script> 
